import React from 'react';
import { Link, Control, Preloader } from 'MWC';
import Calculator from '../../../../auxiliary-components/Calculator';
import '../../less/type.less';
import { LANG } from '../../../../services/l10n';
import Banner from "../../../../auxiliary-components/shared/Banner";
import "../../less/landing/gold.less"
import TabsNew from "../../../../auxiliary-components/shared/TabsNew";
import UsageBlock from "../../../../auxiliary-components/shared/UsageBlock";
import usage_block_data from "../enums/gold_usage_block_data.json";
import Table from "../../../../auxiliary-components/shared/Table";
import table_data from "../enums/gold_table_data.json";
import share_icon from "../../ProjectSupport/img/share_icon.svg";
import DownloadApp from "../../views/downloadApp.c";
import QuestionsBlock from "../../../../auxiliary-components/shared/QuestionsBlock";
import questions from "../enums/gold_questions.json";
import TextAboveFooter from "../../../../auxiliary-components/shared/TextAboveFooter/views/TextAboveFooter.c";
import download_block_img from "../../../GreenCard/img/download_block_img.png";
import FilesForDownload from "../../../../auxiliary-components/shared/FilesForDownload/views/file.c";
import UsageBlockAdmin from '../../../../auxiliary-components/shared/UsageBlockAdmin';

export default function template() {
    const isMobile = this.isViewportMobile(),
        model = this.getModel(),
        {viewport} = this.props,
        modes = [ {mode: 'info', title: 'GREEN_CARD_NAV_TITLE_1'},
            {mode: 'tariffs', title: 'GREEN_CARD_NAV_TITLE_2'},
            {mode: 'questions', title: 'GREEN_CARD_NAV_TITLE_3'}],
        page = 'gold-card',

        tariffsGold = 'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Gold_ua.pdf',

        app = (
            <div className="download-app-wrapper">
                <DownloadApp {...this.props} />
            </div>
        );

    if (model.setRealRate) {
        model.setRealRate(this.l10n('CALCULATOR_CREDIT_CARDS_REAL_YEAR_RATE_1'));
    }

    const calculator = !model.creditSum ? (
            ''
        ) : (
            <div className="credit-calculator">
                <div className="calculator-wrapper">
                    <Calculator model={this.getModel()} type="credit_cards" {...this.props} />
                </div>
            </div>
        );


    return !model.creditSum ?
        <div className="preload-wrapper">
            <Preloader />
        </div> :
        (
            <>
                <div className="gold-card">
                    <Banner
                        img={null}
                        text={'CARDS_GOLD_SUBTITLE-NEW'}
                        textMob={'CARDS_GOLD_SUBTITLE-NEW'}
                        title={'CARDS_GOLD_TITLE-NEW'}
                        toggleModal={null}
                        page={page}
                        isMobile={isMobile}>
                    </Banner>
                    <TabsNew modes={modes} isMobile={isMobile} page={'quick-cash'} toggle={this.toggleMode} mode={this.state.mode}>
                        <div className="wrapper" type={modes[0].mode}>
                            <div className="content">
                                <UsageBlock isMobile={isMobile} page={page} data={usage_block_data} className="col-3-row-1"></UsageBlock>
                                {calculator}
                            </div>
                            {isMobile ?
                                <div className='download-app-wrapper main-page'>
                                    <DownloadApp
                                        desc={'GREEN_CARD_DOWNLOAD_TITLE_DESC'}
                                        title={'GREEN_CARD_DOWNLOAD_TITLE_TEXT'}
                                        {...this.props}
                                        viewport={viewport}
                                        page={page}
                                        img={isMobile ? download_block_img : null}
                                    />
                                </div>
                                : ''
                            }
                        </div>
                        <div className="wrapper" type={modes[1].mode}>
                            <div className="content">
                                <Table data={table_data} page={page} isMobile={isMobile} toggle={this.toggleMode}></Table>
                                <div className="tariffs-desc">
                                    {this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_DESC_TEXT_1')}
                                    <a className="link" href={tariffsGold} target="_blank">
                                        {this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_DESC_TEXT_2')}
                                        <img alt="href_img" src={share_icon}></img>
                                    </a>
                                </div>
                            </div>
                            {app}
                        </div>
                        <div className="wrapper" type={modes[2].mode}>
                            <div className="content">
                                <QuestionsBlock isMobile={isMobile} page={page} data={questions}></QuestionsBlock>
                            </div>
                            {app}
                        </div>
                    </TabsNew>
                    <FilesForDownload lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}></FilesForDownload>
                    <div className={`disclaimer-wrapper tab-${this.state.mode === 'info' ? 'active' : 'hidden'}`}>
                        <TextAboveFooter widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')} isMobile={isMobile}></TextAboveFooter>
                    </div>
                </div>

            </>
        );
}
